<template>
	<div class="box01">
		<v-crumbs :crumbsType="24"></v-crumbs>
		<div class="form_box">
			<div style="flex: 1;overflow: hidden;">
				<template>
					<el-table ref="multipleTable" height="600" :data="list" style="width: 100%" @selection-change="handleSelectionChange">
						<el-table-column type="selection" fixed min-width="46"></el-table-column>
						<el-table-column prop="id" label="ID" min-width="70"></el-table-column>
						<el-table-column prop="username" label="联系人" min-width="130"></el-table-column>
						<el-table-column prop="mobile" label="联系方式" min-width="130"></el-table-column>
						<el-table-column prop="remark" label="需求内容"  min-width="330"></el-table-column>
						<el-table-column prop="fl_name" label="类别" min-width="130"></el-table-column>
						<el-table-column prop="admin_remark" label="备注"></el-table-column>
						<el-table-column prop="handler" label="处理人" min-width="165"></el-table-column>
						<el-table-column prop="createtime_text" label="添加时间" min-width="230"></el-table-column>
						<el-table-column fixed="right" label="操作" min-width="220">
							<template slot-scope="scope">
								<div class="flex04">
									<p class="c_6d9fff m_r10 pointer_" @click="get_detail(scope.row)">查看</p>
									<p class="c_ff6f6f pointer_" @click="get_del(scope.row)">删除</p>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</template>
			</div>
		</div>
		<div class="pagination">
			<el-pagination background :page-size="formInfo.limit" :current-page="formInfo.page" layout="prev, pager, next, jumper"
			 :total="total" @current-change="currentChange"></el-pagination>
		</div>
		<!-- 模态 -->
		<v-modal :type="4" :detail="info" :dialogVisible="dialogVisible" @getModalClose="getModalClose" @get_data_amend="get_data_amend"></v-modal>
	</div>
</template>

<script>
	import modal from '../../components/wx-modal/index.vue'; // 弹窗
	import crumbs from '../../components/crumbs/index.vue'; // 面包屑

	import {
		serviceConsultList,
		serviceConsultShow,
		serviceConsultEdit,
		serviceConsultDel
	} from '@/api/index';

	export default {
		components: {
			'v-modal': modal,
			'v-crumbs': crumbs
		},
		data() {
			return {
				info: {},
				list: [],
				total: null,
				detail_info: {},
				dialogVisible: false,
				formInfo: {
					page: 1,
					limit: 50
				},
			}
		},
		created() {
			this.get_service_consult_list();
		},
		methods: {
			// 列表
			get_service_consult_list() {
				serviceConsultList(this.formInfo).then(res => {
					res.data.data.forEach((n, k) => {
						if (!n.admin_remark) {
							n.admin_remark = '-';
						}

						if (!n.handler) {
							n.handler = '-';
						}

						if (n.service_id) {
							n.fl_name = n.service_type.title
						}

						if (!n.service_id) {
							if (n.type_id == 4) {
								n.fl_name = '官网'
							} else {
								n.fl_name = '首页'
							}
						}
					})

					this.list = res.data.data;
					this.total = res.data.total;
				})
			},
			// 点击页码数
			currentChange(newPage) {
				this.formInfo.page = newPage;
				this.get_service_consult_list();
				window.scroll(0, 0);
			},
			// 查看详情
			get_detail(e) {
				serviceConsultShow({
					id: e.id
				}).then(res => {
					if (!res.data.handler) {
						res.data.handler = '';
					}

					if (!res.data.admin_remark) {
						res.data.admin_remark = '';
					}

					this.info = res.data;
					this.dialogVisible = true;
				})
			},
			getModalClose(e) {
				this.dialogVisible = e
			},
			get_data_amend(e) {
				this.dialogVisible = false;

				serviceConsultEdit({
					id: e.id,
					remark: e.admin_remark,
					handler: e.handler
				}).then(res => {
					this.$message.success('修改成功');
					this.get_service_consult_list();
				})
			},
			// 删除
			get_del(e) {
				this.$confirm('确定删除吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					serviceConsultDel({
						id: e.id
					}).then(res => {
						if (this.formInfo.page != 1 && this.list.length == 1) {
							this.formInfo.page--
						}
						this.get_service_consult_list();
						this.$message.success('删除成功');
					})
				})
			},
			handleSelectionChange(e) {

			},
		}
	}
</script>

<style lang="less" scoped>
	.offer_top {
		margin-bottom: 15px;
	}

	/deep/ .form_box {
		display: flex;

		tr {
			td {
				padding: 20px 0;
			}
		}
	}

	/deep/ .el-image {
		margin: 6px auto;
	}
</style>
